let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9YvvC")).then(() => parcelRequire('1lUBb'));